module.exports = __webpack_public_path__ + "images/4abd850f2827de8b1d3b72798072be43.gif";


//////////////////
// WEBPACK FOOTER
// ./app/images/loader.gif
// module id = 16
// module chunks = 0